import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import createQueryHook from '@segment/utils/createQueryHook';
import { createFsCacheProxy } from '@segment/utils/fsCache';
import { useCatalogIndex } from '@segment/contexts/catalogIndex';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
import { fetchAllCategories } from '../../../staticSiteBackend/catalog';
var keys = ["catalog", "nonEmptyCategoriesQuery"];
export var createNonEmptyCategoriesQuery = function createNonEmptyCategoriesQuery(_ref) {
  var catalogIndex = _ref.catalogIndex,
      staticSiteBackend = _ref.staticSiteBackend;
  return [keys, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var enabled, algoliaCachedSearch, facetsRequest, categoriesRequest, _yield$facetsRequest, facets, categories, integrationsCountPerCategory, categoriesWithAnyIntegrations;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return createFsCacheProxy(keys, catalogIndex.search, {
              enabled: enabled
            });

          case 3:
            algoliaCachedSearch = _context.sent;
            facetsRequest = algoliaCachedSearch("", {
              responseFields: ["facets"],
              facets: ["categories.category.slug"],
              maxValuesPerFacet: 1000
            });
            categoriesRequest = fetchAllCategories(staticSiteBackend);
            _context.next = 8;
            return facetsRequest;

          case 8:
            _yield$facetsRequest = _context.sent;
            facets = _yield$facetsRequest.facets;
            _context.next = 12;
            return categoriesRequest;

          case 12:
            categories = _context.sent;
            integrationsCountPerCategory = facets === null || facets === void 0 ? void 0 : facets["categories.category.slug"];
            categoriesWithAnyIntegrations = categories.filter(function (c) {
              return integrationsCountPerCategory && integrationsCountPerCategory[c.url];
            });
            return _context.abrupt("return", categoriesWithAnyIntegrations.map(function (c) {
              return {
                name: c.name,
                slug: c.url
              };
            }));

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))];
};
export var useNonEmptyIntegrationsQuery = createQueryHook(createNonEmptyCategoriesQuery, function () {
  var catalogIndex = useCatalogIndex();
  var staticSiteBackend = useStaticSiteBackend();
  return {
    catalogIndex: catalogIndex,
    staticSiteBackend: staticSiteBackend
  };
}, {
  staleTime: Infinity
});